import { useState, type KeyboardEvent } from 'react';
import { Send } from 'lucide-react';
import { Button } from '@atoms/Button';

interface ChatComposerProps {
  onSend: (content: string) => void;
  onTyping?: (isTyping: boolean) => void;
  loading?: boolean;
  placeholder?: string;
}

export function ChatComposer({
  onSend,
  onTyping,
  loading,
  placeholder = 'Mesaj yazın…',
}: ChatComposerProps) {
  const [value, setValue] = useState('');

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || loading) return;
    onSend(trimmed);
    setValue('');
    onTyping?.(false);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div className="flex items-end gap-2 border-t border-slate-200 bg-white p-3 shrink-0">
      <textarea
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          onTyping?.(e.target.value.trim().length > 0);
        }}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        rows={1}
        className="max-h-32 min-h-[44px] flex-1 resize-none rounded-xl border border-slate-200 px-3 py-2.5 text-sm focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20"
      />
      <Button
        size="md"
        loading={loading}
        disabled={!value.trim()}
        onClick={submit}
        aria-label="Gönder"
        className="h-11 w-11 shrink-0 px-0"
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );
}
